"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetLinkIdentifier = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.DatasetLinkIdentifier = {
    HYDRAULIC_NODE_RESULTS_PRESSURE_METERS: 'HYDRAULIC_NODE_RESULTS_PRESSURE_METERS',
    HYDRAULIC_NODE_RESULTS_PRESSURE_PA: 'HYDRAULIC_NODE_RESULTS_PRESSURE_PA',
    HYDRAULIC_NODE_RESULTS_TEMPERATURE_CELSIUS: 'HYDRAULIC_NODE_RESULTS_TEMPERATURE_CELSIUS',
    HYDRAULIC_NODE_RESULTS_ENTHALPY: 'HYDRAULIC_NODE_RESULTS_ENTHALPY',
    HYDRAULIC_NODE_RESULTS_DENSITY: 'HYDRAULIC_NODE_RESULTS_DENSITY',
    HYDRAULIC_ELEMENT_PRESSURE_LOSSES_M: 'HYDRAULIC_ELEMENT_PRESSURE_LOSSES_M',
    HYDRAULIC_ELEMENT_PRESSURE_LOSSES_PA: 'HYDRAULIC_ELEMENT_PRESSURE_LOSSES_PA',
    HYDRAULIC_ELEMENT_MECHANICAL_LOSSES_W: 'HYDRAULIC_ELEMENT_MECHANICAL_LOSSES_W',
    HYDRAULIC_ELEMENT_FLOW_RATE: 'HYDRAULIC_ELEMENT_FLOW_RATE',
    HYDRAULIC_ELEMENT_FLOW_SPEED: 'HYDRAULIC_ELEMENT_FLOW_SPEED',
    HYDRAULIC_ELEMENT_DENSITY: 'HYDRAULIC_ELEMENT_DENSITY',
    HYDRAULIC_ELEMENT_EXCHANGE_RATE: 'HYDRAULIC_ELEMENT_EXCHANGE_RATE',
    HYDRAULIC_ELEMENT_P_THERMAL: 'HYDRAULIC_ELEMENT_P_THERMAL',
    HYDRAULIC_ELEMENT_P_THERMAL_REAL: 'HYDRAULIC_ELEMENT_P_THERMAL_REAL',
    HYDRAULIC_ELEMENT_MASS_FLOW_RATE: 'HYDRAULIC_ELEMENT_MASS_FLOW_RATE',
    HYDRAULIC_ELEMENT_PRESSURE_PA: 'HYDRAULIC_ELEMENT_PRESSURE_PA',
    THERMAL_LOAD_POWER_CONSUMPTION_HOT_WATER: 'THERMAL_LOAD_POWER_CONSUMPTION_HOT_WATER',
    ITEM_CONNECTIVITY_STATE: 'ITEM_CONNECTIVITY_STATE',
    HYDRAULIC_NODE_BASE_TEMPERATURE: 'HYDRAULIC_NODE_BASE_TEMPERATURE',
    HYDRAULIC_NODE_BASE_PRESSURE: 'HYDRAULIC_NODE_BASE_PRESSURE',
    HYDRAULIC_NODE_IS_BASE_NODE: 'HYDRAULIC_NODE_IS_BASE_NODE',
    HYDRAULIC_ISLAND_THERMAL_POWER_GENERATED: 'HYDRAULIC_ISLAND_THERMAL_POWER_GENERATED',
    HYDRAULIC_ISLAND_THERMAL_POWER_CONSUMED: 'HYDRAULIC_ISLAND_THERMAL_POWER_CONSUMED',
    HYDRAULIC_ISLAND_THERMAL_POWER_LOSSES_IN_PIPES: 'HYDRAULIC_ISLAND_THERMAL_POWER_LOSSES_IN_PIPES',
    HYDRAULIC_ISLAND_THERMAL_POWER_CONSUMED_IN_LOADS: 'HYDRAULIC_ISLAND_THERMAL_POWER_CONSUMED_IN_LOADS',
    HYDRAULIC_ISLAND_CALCULATION_AMBIENT_TEMPERATURE: 'HYDRAULIC_ISLAND_CALCULATION_AMBIENT_TEMPERATURE',
    HYDRAULIC_ISLAND_MIN_PRESSURE: 'HYDRAULIC_ISLAND_MIN_PRESSURE',
    HYDRAULIC_ISLAND_MAX_PRESSURE: 'HYDRAULIC_ISLAND_MAX_PRESSURE',
    HYDRAULIC_ISLAND_MIN_TEMPERATURE: 'HYDRAULIC_ISLAND_MIN_TEMPERATURE',
    HYDRAULIC_ISLAND_MAX_TEMPERATURE: 'HYDRAULIC_ISLAND_MAX_TEMPERATURE',
    HYDRAULIC_ISLAND_PRESSURE_LOSSES_IN_PIPES: 'HYDRAULIC_ISLAND_PRESSURE_LOSSES_IN_PIPES',
    HYDRAULIC_ISLAND_MECHANICAL_POWER_LOSSES_IN_PIPES: 'HYDRAULIC_ISLAND_MECHANICAL_POWER_LOSSES_IN_PIPES',
    HYDRAULIC_ISLAND_THERMAL_RESULT_VALID: 'HYDRAULIC_ISLAND_THERMAL_RESULT_VALID',
    AMBIENT_TEMPERATURE: 'AMBIENT_TEMPERATURE',
    PUMP_CALCULATION_RPM: 'PUMP_CALCULATION_RPM',
    TARGET_DELTA_TEMPERATURE: 'TARGET_DELTA_TEMPERATURE',
    HYDRAULIC_PUMP_ROTATION_SPEED_RPM: 'HYDRAULIC_PUMP_ROTATION_SPEED_RPM',
    THERMAL_LOAD_POWER_CONSUMPTION_HEATING: 'THERMAL_LOAD_POWER_CONSUMPTION_HEATING',
    THERMAL_LOAD_REQUIRED_FLOW_RATE: 'THERMAL_LOAD_REQUIRED_FLOW_RATE'
};
//# sourceMappingURL=dataset-link-identifier.js.map